export const environment = {
  production: false,
  url: "https://ud-api.fof-fuso.com/eolmonitoringapi",
  appMonitoringurl: "https://ud-api.fof-fuso.com/appmonitoringiam",
  refresh_token_url:"https://ud-api.fof-fuso.com/tokenrefresh/redirect/eolmonitoring",
  eol_url:"https://ud-api.fof-fuso.com/eoliam",
  loginUrl_SSO:"https://d-redirect.fof-fuso.com/eolmonitoringapp",
  logoutUrl_SSO:"https://login.microsoftonline.com/505cca53-5750-4134-9501-8d52d5df3cd1/oauth2/v2.0/logout",
  saas_token: '?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2027-09-02T19:37:57Z&st=2023-09-01T11:37:57Z&spr=https&sig=8bfUkvXYKqpQSJB81IdhfvLXG5ufKBqQzP6F%2B6RXjac%3D'

};

